// extracted by mini-css-extract-plugin
module.exports = {"switchBar":"trWcs","frameHolder":"N0CbE"};